import React, { useEffect, useState } from "react";

import { yupResolver } from "@hookform/resolvers/yup";
import classNames from "classnames";
import { decode } from "he";
import { Button, Input, Informer } from "ii-ui-kit";
import { useForm } from "react-hook-form";
import "./register-phone-form.scss";
import { SubmitHandler } from "react-hook-form/dist/types/form";

import { registerPhoneFormSchema } from "consts";
import { clearFormError } from "utils/clear-form-error/clear-form-error";
import { declOfNum } from "utils/decl-of-num/decl-of-num";
import { postForm } from "utils/post-form/post-form";

import { useIsUserBlocked } from "../hooks/use-is-user-blocked";

import { IRegisterPhoneFormProps, IRegisterPhoneFormFields } from "./types";

export const RegisterPhoneForm: React.FC<IRegisterPhoneFormProps> = ({
  className,
}) => {
  /** Форма отправляется ? */
  const [isFormSending, setIsFormSending] = useState(false);
  const {
    register,
    handleSubmit,
    setError,
    formState: { errors },
  } = useForm<IRegisterPhoneFormFields>({
    mode: "onBlur",
    resolver: yupResolver(registerPhoneFormSchema),
  });

  const { isUserBlocked, timeBlock } = useIsUserBlocked();

  useEffect(() => {
    if (window.errorOnErrorPage === "smsAuthSmsNotSent") {
      setError("phone", { message: "Некорректный номер" });
      return;
    }
  }, [window.errorOnErrorPage]);

  const onSubmit: SubmitHandler<IRegisterPhoneFormFields> = (data) => {
    if (!window.loginAction) {
      return;
    }

    setIsFormSending(true);
    const preparedData = {
      ...data,
      phone: data.phone.replace(/\D/g, "").slice(1),
    };
    clearFormError();
    postForm(
      window.loginAction ? decode(window.loginAction) : "",
      preparedData
    );
  };

  return (
    <form
      className={classNames(className, "register-phone-form")}
      onSubmit={handleSubmit(onSubmit)}
    >
      <Input
        addContainerClass={"register-phone-form__phone-input"}
        id={"phoneNumber"}
        label={"Номер телефона"}
        placeholder={"Номер телефона"}
        inputMode={"tel"}
        mask={"+7(999)-999-99-99"}
        autoFocus={true}
        form={"formField"}
        errorText={errors["phone"]?.message}
        validationStatus={errors["phone"] ? "error" : undefined}
        {...register("phone")}
      />
      <Informer
        className={"register-phone-form__informer"}
        isOpen={isUserBlocked}
        isDisplayIcon={true}
        type={"danger"}
        title={"Превышено число попыток"}
        text={
          isUserBlocked && timeBlock
            ? `В целях безопасности вход в личный кабинет заблокирован на ${timeBlock} ${declOfNum(
                timeBlock,
                "минут|у|ы|"
              )}`
            : ""
        }
      />
      <Button
        isLoading={isFormSending}
        className={"register-phone-form__button"}
        title={"Продолжить"}
        size={"m"}
      />
      <div className="register-phone-form__text">
        <p>
            <span>Нажимая «Продолжить», вы разрешаете АО УК «Ингосстрах-Инвестиции» проверить наличие указанного номера в базе данных и соглашаетесь получить SMS для аутентификации, а также соглашаетесь с сохранением файлов «cookie» и обработкой обезличенных пользовательских технических и аналитических данных с применением сервиса «Яндекс.Метрика» в соответствии с </span>
            <a href="https://www.ingosinvest-am.ru/api/uploads/Politika_obrabotki_P_Dn_ot_15_02_2023_70072661e0.pdf" target="_blank"><span className="register-phone-form__href">Политикой обработки персональных данных</span></a>
            <span> для проведения маркетингового анализа, персонализации сервиса и обеспечения работы пользователей с данным сайтом. Вы также можете запретить сохранение файлов «cookie» в настройках своего браузера.</span>
        </p>
      </div>
    </form>
  );
};
